import React from 'react';
import PropTypes from 'prop-types';
// import Markdown from 'markdown-to-jsx';
import { useEntity } from 'entities/hooks';
import { Box, Text } from 'rebass';
import 'react-quill/dist/quill.bubble.css';

const TextMedium = ({ id, editing }) => {
  const { entity } = useEntity({ id, type: 'texts' });
  return (
    <Box bg="white" sx={{
      borderRadius: '10px'
    }} className="quill ql-lifetales" width="100%" p="20px" pt={editing ? 4 : 2}>
      <Text
        fontFamily="Poppins"
        color={entity?.position === 1 ? "#64748B" : "#0E0E0E"}
        fontSize="15px" fontStyle={entity?.position === 1 && "italic"}
        lineHeight="150%"
        dangerouslySetInnerHTML={{ __html: entity.text }}
      />
    </Box>
  );
};

TextMedium.propTypes = {
  id: PropTypes.string.isRequired,
  editing: PropTypes.bool,
};

TextMedium.defaultProps = {
  editing: false,
};

export default TextMedium;
